import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useGetPolls = ({
  shouldFetchTemplates,
  assignmentId,
  language,
  skip,
}) => {
  const params = {
    ...(shouldFetchTemplates && { is_template: 1 }),
    ...(assignmentId && { assignment_id: assignmentId }),
    ...(language && { language }),
  };
  const queryString = new URLSearchParams(params).toString();
  const resource = `${MONOLITH_ORIGIN}/api/v3/activity/?${queryString}`;

  return useRestQuery(resource, {
    skip: skip || (!shouldFetchTemplates && !assignmentId),
  });
};

export default useGetPolls;
